module.exports = __webpack_public_path__ + "static/audio-568d73eee51ee4a7d1a7d0572740e613.jpg";